import React from "react";
import Modal from "../../../common/Modal/Modal";

export default function RegFixEmail(props) {
    return (
        <Modal hasBackButton={true} handleBack={props.handleBack} className="login" >
            { props.selectedCompany &&
                <>
                    <div className="flex-column" >
                        <p className="content2 light-black text-center gap-above-m" >The email address you have provided does not match the addresses for this company.</p>
                        <p className="content2 heavy text-center gap-above-m gap-below-s" >Please provide your official company email address in order to complete registration.</p>
                    </div>
                    <div className="w100" >
                        <form className="form" onSubmit={(e) => props.onSubmit(e)} >	
                            <div className="flex-row gap-above-s gap-below-m" >	
                                <div className="inputs-wrapper " style={{width: "50%"}} >
                                    <div className="input-basic addspace" > 
                                        <input
                                            type="text"
                                            name="revised_email"
                                            onChange={(e) => props.onChange(e)}
                                            id="revised_email"
                                            value={props.revisedEmail}
                                            placeholder="myname"
                                            required
                                        />
                                        <label htmlFor="revised_email" ></label>
                                    </div>
                                </div>
                                <div style={{justifyContent: "center", width: "50%"}} className="flex-column g9" >
                                    <p className="content1 heavy" style={{padding: "14px 12px 0 0"}} >@{props.selectedCompany.domain}</p>
                                </div>
                            </div>
                            <button type="submit" id="register" className="btn pri gap-below-m" disabled={props.isSubmitting} >{props.isSubmitting ? "SIGNING UP..." : "SIGN UP"}</button>
                        </form>
                    </div>
                </>
            }
        </Modal>
    )
} 
